export default "__VITE_ASSET__DmIAx6j3__"